module.exports = __webpack_public_path__ + "static/cf-med-italic-ad17992cdd25c5dcddeb9fe79407be73.woff";